<template>
  <div class="c15">
    <p class="c1">
      <span
        style="
          overflow: hidden;
          display: inline-block;
          margin: 0px 0px;
          border: 0px solid #000000;
          transform: rotate(0rad) translateZ(0px);
          -webkit-transform: rotate(0rad) translateZ(0px);
          width: 193.01px;
          height: 173.5px;
        "
      ><img
        alt=""
        src="@/app-assets/images/legals/image1.png"
        style="
            width: 193.01px;
            height: 173.5px;
            margin-left: 0px;
            margin-top: 0px;
            transform: rotate(0rad) translateZ(0px);
            -webkit-transform: rotate(0rad) translateZ(0px);
          "
        title="" /></span
      ><span
      style="
          overflow: hidden;
          display: inline-block;
          margin: 0px 0px;
          border: 0px solid #000000;
          transform: rotate(0rad) translateZ(0px);
          -webkit-transform: rotate(0rad) translateZ(0px);
          width: 200.87px;
          height: 200.87px;
        "
    ><img
      alt=""
      src="@/app-assets/images/legals/image2.png"
      style="
            width: 200.87px;
            height: 200.87px;
            margin-left: 0px;
            margin-top: 0px;
            transform: rotate(0rad) translateZ(0px);
            -webkit-transform: rotate(0rad) translateZ(0px);
          "
      title=""
    /></span>
    </p>
    <p class="c1">
      <span class="c13">&nbsp;</span
      ><span class="c14"
    >{{ $t("privacy_policy_module_heading_privacy_policy") }} &ndash; {{ $t("privacy_policy_module_heading_pacto") }}</span
    >
    </p>
    <h1 class="c1 c4" id="h.s6avdzeuph8q">
      <span class="c7">{{ $t("privacy_policy_module_introduction_heading") }}</span>
    </h1>
    <p class="c1">
      <span class="c2">{{
          $t(
            "privacy_policy_module_thanks_message"
          )
        }}</span>
    </p>
    <p class="c1">
      <span class="c2"
      >{{$t(
        'privacy_policy_module_intro'
      )}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.w3j4jiui7m8c">
      <span class="c5">{{$t('privacy_policy_module_introduction_subtopic_data_controller')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t(
        'privacy_policy_module_heading_for_data_controller_privacy_policy'
      )}}</span>
    </p>
    <p class="c1 c9">
      <span class="c2"
      >{{$t('privacy_policy_module_organisation_data_controller_privacy_policy')}}</span
      >
    </p>
    <p class="c1 c9">
      <span class="c2">{{$t('privacy_policy_module_organisation_details')}}</span>
    </p>
    <p class="c1">
      <span class="c2"
      >&nbsp;{{$t('privacy_policy_module_privacy_policy_for_data_controller')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
      >&nbsp;{{$t('privacy_policy_module_privacy_policy_for_data_controller_1.1.5')}}</span>
    </p>
    <h1 class="c1 c4" id="h.36y65oqh6vsn">
      <span class="c7">{{$t('privacy_policy_module_heading_information_we_collect')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_data_to_be_collected')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.2b83f6lm9n1y">
      <span class="c5"
      >{{$t('privacy_policy_module_heading_information_you_give_2.1')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_information_you_give_2.1.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_q5klg7mmrj8o-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.1.2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.1.3')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.1.4')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.1.5')}}</span>
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.1.6')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.bsif8y29qnuf">
      <span class="c5"
      >{{$t('privacy_policy_module_information_you_give_2.2_heading')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_information_you_give_2.2.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_l3l0j2ddglvo-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.2.2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.2.3')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.nmq8a5imal4u">
      <span class="c5"
      >{{$t('privacy_policy_module_information_you_give_2.3_heading')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_information_you_give_2.3.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_m4m2h68vnyuh-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_geolocation_heading')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.3.3')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_you_give_2.3.4')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.9h013cgo3z7d">
      <span class="c5"
      >{{$t('privacy_policy_module_information_collected_from_third_party_heading_2.4')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_information_collected_from_third_party_2.4.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_mgfotgex9o4o-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_information_collected_from_third_party_2.4.2')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.o0fg1r4z9r2k">
      <span class="c5">{{$t('privacy_policy_module_children_data_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_children_data_2.5.1')}}</span
      >
    </p>
    <h1 class="c1 c4" id="h.7ww66mct986m">
      <span class="c7">{{$t('privacy_policy_module_organisation_uses_information_we_collect_heading')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_organisation_uses_information_we_collect_details')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.j3xh5hx030gf">
      <span class="c5"
      >{{$t('privacy_policy_module_organisation_uses_information_we_collect_3.1')}}</span
      >
    </h2>
    <ul class="c0 lst-kix_4kwv5o75cxnv-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_enable_safe_nightsrest_app')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_enable_communication_with_other_users')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_organisation_uses_information_we_collect_3.1.3')}}</span
        >
      </li>
      <li class="c1 c6"><span class="c2">{{$t('privacy_policy_module_customer_services')}}</span></li>
      <li class="c1 c6">
        <span class="c2">{{$t('privacy_policy_module_send_service_or_support_messages')}}</span>
      </li>
      <li class="c1 c6">
        <span class="c2">{{$t('privacy_policy_module_listing_leased_property')}}</span>
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_3.1.7')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_enable_e_documents')}}</span
        >
      </li>
    </ul>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_3.1.9')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.p8brhtvez88c">
      <span class="c5"
      >{{$t('privacy_policy_module_3.2')}}</span
      >
    </h2>
    <ul class="c0 lst-kix_xod5q0hzxcvd-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_harmfull_activity')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_for_safety')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2">{{$t('privacy_policy_module_for_legal_obligations')}}</span>
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_for_disputes_amoung_users_and_enforce_agrements')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2">{{$t('privacy_policy_module_ensure_service_and_policies')}}</span>
      </li>
    </ul>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_create_and_maintain_environment')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_create_and_maintain_environment2')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.ncp8sdib7eru">
      <span class="c5"
      >{{$t('privacy_policy_module_3.3_heading')}}</span
      >
    </h2>
    <ul class="c0 lst-kix_9mghw7k5etl-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_for_measure_and_report_on_social_impact_outcomes_1')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_for_measure_and_report_on_social_impact_outcomes_2')}}</span
        >
      </li>
    </ul>
    <h1 class="c1 c4" id="h.gqo7ggtpln1q">
      <span class="c7">{{$t('privacy_policy_module_sharing_and_disclosure_heading')}}</span>
    </h1>
    <h2 class="c1 c4" id="h.dp13mec6ymt">
      <span class="c5">{{$t('privacy_policy_module_4.1_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_sharing_between_users_1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_l02k23gi25pu-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_sharing_between_users_2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_sharing_between_users_3')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_sharing_between_users_4')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.8slawf9dvvez">
      <span class="c5"
      >{{$t('privacy_policy_4.2_heading')}}</span
      >
    </h2>
    <ul class="c0 lst-kix_4rggbr1cbnyr-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_4.2.1')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_4.2.2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_4.2.3')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.sghoq1gfc0md">
      <span class="c5">{{$t('privacy_policy_module_4.3_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_4.3.1')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
      >&nbsp;{{$t('privacy_policy_module_4.3.2')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.e7pmhwfleet9">
      <span class="c5">{{$t('privacy_policy_module_4.4_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_4.4.1')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.4s6z7xj16onb">
      <span class="c5">{{$t('privacy_policy_module_4.5_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_4.5.1')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.z57jx074xm8u">
      <span class="c5">{{$t('privacy_policy_module_4.6_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_4.6.1')}}</span
      >
    </p>
    <h1 class="c1 c4" id="h.hxvdtizh0qh1">
      <span class="c7">{{$t('privacy_policy_module_5_heading')}}</span>
    </h1>
    <h2 class="c1 c4" id="h.kggwes6v9t8d">
      <span class="c5">{{$t('privacy_policy_module_5.1')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_5.1.1')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_5.1.2')}}</span
      >
    </p>
    <h1 class="c1 c4" id="h.mkh81lj22x8k">
      <span class="c7">{{$t('privacy_policy_module_6_heading')}}</span>
    </h1>
    <h2 class="c1 c4" id="h.64twxehxkggb">
      <span class="c5">{{$t('privacy_policy_module_6.1')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.1.1')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.kg4jpjq15vdg">
      <span class="c5"
      >{{$t('privacy_policy_module_6.2_heading')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.2.1')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.jrl0f3xr1s1n">
      <span class="c5">{{$t('privacy_policy_module_6.3_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.3.1')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.pcfogif3ksmw">
      <span class="c5">{{$t('privacy_policy_module_6.4_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.4.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_bedya2rhf0x1-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_6.4.2')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_6.4.3')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_6.4.4')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_6.4.5')}}</span
        >
      </li>
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_6.4.6')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.ny9xda91ir45">
      <span class="c5"
      >{{$t('privacy_policy_module_6.5_heading')}}</span
      >
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.5.1')}}</span
      >
    </p>
    <ul class="c0 lst-kix_ugipqntlnkiw-0 start">
      <li class="c1 c6">
        <span class="c2"
        >{{$t('privacy_policy_module_6.5.2')}}</span
        >
      </li>
    </ul>
    <h2 class="c1 c4" id="h.gjqr9cmaoptq">
      <span class="c5">{{$t('privacy_policy_module_6.6_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.6.1')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.6.2')}}</span
      >
    </p>
    <h2 class="c1 c4" id="h.hhnwrsbccyu7">
      <span class="c5">{{$t('privacy_policy_module_6.7_heading')}}</span>
    </h2>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.7.1')}}</span
      >
    </p>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_6.7.2')}}</span
      >
    </p>
    <p class="c1 c10">
      <span class="c2"
      >https://www.datatilsynet.no/rettigheter-og-plikter/den-registrertes-rettigheter/</span
      >
    </p>
    <h1 class="c1 c4" id="h.tcgbutysg0pn">
      <span class="c7">{{$t('privacy_policy_module_7_heading')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_7.1')}}</span
      >
    </p>
    <h1 class="c1 c4" id="h.3y0yx87p6018">
      <span class="c7">{{$t('privacy_policy_module_8')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_8.1')}}</span
      >
    </p>
    <h1 class="c4 c11" id="h.a3crkqhwb0eu">
      <span class="c7">{{$t('privacy_policy_module_9')}}</span>
    </h1>
    <p class="c1">
      <span class="c2"
      >{{$t('privacy_policy_module_data_processing')}}
      </span>
    </p>
    <p class="c1 c8"><span class="c2">data.protection@nrc.no</span></p>
    <p class="c1"><span class="c2">&nbsp;</span></p>
    <p class="c1"><span class="c2">&nbsp;</span></p>
    <p class="c12"><span class="c2"></span></p>
  </div>
</template>

<script>
export default {};
</script>

<style type="text/css" scoped>
@import url("https://themes.googleusercontent.com/fonts/css?kit=dpiI8CyVsrzWsJLBFKehGpLhv3qFjX7dUn1mYxfCXhI");

.lst-kix_l3l0j2ddglvo-0 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_9mghw7k5etl-0 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-2 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-1 {
  list-style-type: none;
}

.lst-kix_l3l0j2ddglvo-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l3l0j2ddglvo-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_l3l0j2ddglvo-4 > li:before {
  content: "\0025cb  ";
}

ul.lst-kix_9mghw7k5etl-8 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-7 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-4 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-3 {
  list-style-type: none;
}

.lst-kix_l3l0j2ddglvo-3 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_9mghw7k5etl-6 {
  list-style-type: none;
}

ul.lst-kix_9mghw7k5etl-5 {
  list-style-type: none;
}

.lst-kix_l3l0j2ddglvo-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_q5klg7mmrj8o-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_q5klg7mmrj8o-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l3l0j2ddglvo-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l3l0j2ddglvo-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_q5klg7mmrj8o-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_q5klg7mmrj8o-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_q5klg7mmrj8o-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l3l0j2ddglvo-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_q5klg7mmrj8o-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_q5klg7mmrj8o-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_q5klg7mmrj8o-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_q5klg7mmrj8o-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_4rggbr1cbnyr-8 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-6 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-7 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-4 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-5 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-2 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-3 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-0 {
  list-style-type: none;
}

ul.lst-kix_4rggbr1cbnyr-1 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-1 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-2 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-0 {
  list-style-type: none;
}

.lst-kix_bedya2rhf0x1-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_bedya2rhf0x1-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_m4m2h68vnyuh-7 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-8 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-5 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-6 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-3 {
  list-style-type: none;
}

ul.lst-kix_m4m2h68vnyuh-4 {
  list-style-type: none;
}

.lst-kix_ugipqntlnkiw-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_xod5q0hzxcvd-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_xod5q0hzxcvd-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_xod5q0hzxcvd-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_xod5q0hzxcvd-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_ugipqntlnkiw-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_xod5q0hzxcvd-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_ugipqntlnkiw-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_ugipqntlnkiw-3 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_4kwv5o75cxnv-7 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-6 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-8 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-8 {
  list-style-type: none;
}

.lst-kix_mgfotgex9o4o-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_l02k23gi25pu-7 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-6 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-1 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-5 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-0 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-4 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-3 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-3 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-2 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-2 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-5 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-1 {
  list-style-type: none;
}

ul.lst-kix_4kwv5o75cxnv-4 {
  list-style-type: none;
}

ul.lst-kix_l02k23gi25pu-0 {
  list-style-type: none;
}

.lst-kix_mgfotgex9o4o-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4rggbr1cbnyr-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_4rggbr1cbnyr-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_bedya2rhf0x1-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_mgfotgex9o4o-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_4rggbr1cbnyr-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_bedya2rhf0x1-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_bedya2rhf0x1-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4rggbr1cbnyr-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_mgfotgex9o4o-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_mgfotgex9o4o-8 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_q5klg7mmrj8o-0 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_9mghw7k5etl-6 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_q5klg7mmrj8o-4 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-3 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_9mghw7k5etl-8 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_q5klg7mmrj8o-2 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-1 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-8 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-7 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_9mghw7k5etl-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_q5klg7mmrj8o-6 {
  list-style-type: none;
}

ul.lst-kix_q5klg7mmrj8o-5 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-3 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_ugipqntlnkiw-6 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-7 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-4 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-5 {
  list-style-type: none;
}

.lst-kix_m4m2h68vnyuh-0 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_ugipqntlnkiw-2 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-3 {
  list-style-type: none;
}

.lst-kix_9mghw7k5etl-7 > li:before {
  content: "\0025cb  ";
}

ul.lst-kix_ugipqntlnkiw-0 {
  list-style-type: none;
}

ul.lst-kix_ugipqntlnkiw-1 {
  list-style-type: none;
}

.lst-kix_4kwv5o75cxnv-4 > li:before {
  content: "\0025cb  ";
}

ul.lst-kix_ugipqntlnkiw-8 {
  list-style-type: none;
}

.lst-kix_4kwv5o75cxnv-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4kwv5o75cxnv-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4kwv5o75cxnv-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4kwv5o75cxnv-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_9mghw7k5etl-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l02k23gi25pu-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l02k23gi25pu-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_l02k23gi25pu-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4kwv5o75cxnv-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4kwv5o75cxnv-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_m4m2h68vnyuh-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_m4m2h68vnyuh-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4kwv5o75cxnv-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_m4m2h68vnyuh-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_m4m2h68vnyuh-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4kwv5o75cxnv-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_m4m2h68vnyuh-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l02k23gi25pu-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_m4m2h68vnyuh-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l02k23gi25pu-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_l02k23gi25pu-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_l02k23gi25pu-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l02k23gi25pu-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_m4m2h68vnyuh-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_l02k23gi25pu-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_m4m2h68vnyuh-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_bedya2rhf0x1-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_ugipqntlnkiw-6 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_xod5q0hzxcvd-5 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-6 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-3 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-4 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-1 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-2 {
  list-style-type: none;
}

.lst-kix_ugipqntlnkiw-8 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_xod5q0hzxcvd-0 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-3 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-4 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-5 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-6 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-0 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-1 {
  list-style-type: none;
}

.lst-kix_xod5q0hzxcvd-1 > li:before {
  content: "\0025cb  ";
}

ul.lst-kix_xod5q0hzxcvd-7 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-2 {
  list-style-type: none;
}

ul.lst-kix_xod5q0hzxcvd-8 {
  list-style-type: none;
}

.lst-kix_xod5q0hzxcvd-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_xod5q0hzxcvd-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_ugipqntlnkiw-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_xod5q0hzxcvd-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_ugipqntlnkiw-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_ugipqntlnkiw-2 > li:before {
  content: "\0025a0  ";
}

ul.lst-kix_l3l0j2ddglvo-6 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-7 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-4 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-5 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-2 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-3 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-0 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-1 {
  list-style-type: none;
}

ul.lst-kix_l3l0j2ddglvo-8 {
  list-style-type: none;
}

.lst-kix_mgfotgex9o4o-1 > li:before {
  content: "\0025cb  ";
}

.lst-kix_mgfotgex9o4o-3 > li:before {
  content: "\0025cf  ";
}

ul.lst-kix_bedya2rhf0x1-8 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-7 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-6 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-5 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-4 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-3 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-2 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-1 {
  list-style-type: none;
}

ul.lst-kix_bedya2rhf0x1-0 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-7 {
  list-style-type: none;
}

ul.lst-kix_mgfotgex9o4o-8 {
  list-style-type: none;
}

.lst-kix_4rggbr1cbnyr-8 > li:before {
  content: "\0025a0  ";
}

.lst-kix_mgfotgex9o4o-5 > li:before {
  content: "\0025a0  ";
}

.lst-kix_4rggbr1cbnyr-6 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4rggbr1cbnyr-0 > li:before {
  content: "\0025cf  ";
}

.lst-kix_4rggbr1cbnyr-4 > li:before {
  content: "\0025cb  ";
}

.lst-kix_bedya2rhf0x1-3 > li:before {
  content: "\0025cf  ";
}

.lst-kix_bedya2rhf0x1-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_mgfotgex9o4o-7 > li:before {
  content: "\0025cb  ";
}

.lst-kix_4rggbr1cbnyr-2 > li:before {
  content: "\0025a0  ";
}

.lst-kix_bedya2rhf0x1-5 > li:before {
  content: "\0025a0  ";
}

ol {
  margin: 0;
  padding: 0;
}

table td,
table th {
  padding: 0;
}

.c3 {
  color: #ff7800;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c7 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 20pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c12 {
  padding-top: 0pt;
  padding-bottom: 0pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
  height: 11pt;
}

.c14 {
  color: #ff7800;
  font-weight: 700;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 23pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c5 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 16pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c2 {
  color: #000000;
  font-weight: 400;
  text-decoration: none;
  vertical-align: baseline;
  font-size: 11pt;
  font-family: "Roboto", sans-serif;
  font-style: normal;
}

.c1 {
  padding-top: 12pt;
  padding-bottom: 12pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c11 {
  padding-top: 20pt;
  padding-bottom: 6pt;
  line-height: 1.15;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.c13 {
  font-family: "Roboto", sans-serif;
  color: #ff7800;
  font-weight: 400;
}

.c15 {
  background-color: #ffffff;
  width: 100%;
  padding: 72pt 72pt 72pt 72pt;
}

.c6 {
  margin-left: 36pt;
  padding-left: 0pt;
}

.c0 {
  padding: 0;
  margin: 0;
}

.c8 {
  margin-left: 36pt;
  text-indent: 36pt;
}

.c9 {
  margin-left: 36pt;
}

.c4 {
  page-break-after: avoid;
}

.c10 {
  text-indent: 36pt;
}

.title {
  padding-top: 0pt;
  color: #000000;
  font-size: 26pt;
  padding-bottom: 3pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

.subtitle {
  padding-top: 0pt;
  color: #666666;
  font-size: 15pt;
  padding-bottom: 16pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

li {
  color: #000000;
  font-size: 11pt;
  font-family: "Arial", sans-serif;
}

p {
  margin: 0;
  color: #000000;
  font-size: 11pt;
  font-family: "Arial", sans-serif;
}

h1 {
  padding-top: 20pt;
  color: #000000;
  font-size: 20pt;
  padding-bottom: 6pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h2 {
  padding-top: 18pt;
  color: #000000;
  font-size: 16pt;
  padding-bottom: 6pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h3 {
  padding-top: 16pt;
  color: #434343;
  font-size: 14pt;
  padding-bottom: 4pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h4 {
  padding-top: 14pt;
  color: #666666;
  font-size: 12pt;
  padding-bottom: 4pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h5 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  orphans: 2;
  widows: 2;
  text-align: left;
}

h6 {
  padding-top: 12pt;
  color: #666666;
  font-size: 11pt;
  padding-bottom: 4pt;
  font-family: "Arial", sans-serif;
  line-height: 1.15;
  page-break-after: avoid;
  font-style: italic;
  orphans: 2;
  widows: 2;
  text-align: left;
}
</style>
